<template lang="pug">
  div(:class="{'parent--container':isParent, 'my--container': isMe, 'qcw-group': isGroupRoom, 'contain-date': showDate, 'deleted': isDeleted }")
    div(class='qcw-comment-container' :id="comment.id" :class="{[`qcw-comment--${this.comment.type}`]: true,'comment--me': isMe, 'qcw-comment--cust': isCustomer, 'qcw-comment--sticker': isSticker}")
      div(v-if="showDate" class="qcw-comment-date")
        div {{ dateToday }}
      div(v-if="comment.type == 'system_event'" class="qcw-comment--system-event")
        comment-custom(v-if="core.customTemplate && haveTemplate(comment)" :data="comment")
        div(v-else)
          div {{unsanitizeHTML(timestamp+" - "+ comment.message) }}

      div
        div(
          class="qcw-comment"
          v-if="comment.type != 'system_event'"
          :class="{ 'comment--me': isMe, 'comment--parent': isParent, 'comment--mid': isMid, 'comment--last': isLast && !isCarousel && !comment.extras.is_echo, 'comment--last-carousel':  isLast && isCarousel }"
        )
          div(class="qcw-comment__message"
            :style="messageStyle"
            :class="{'message__image': isMeFileImageAttachment,'message__bot': isReplayBot,'extra-margin carousel': comment.type === 'carousel','sticker':isSticker  && !isStickerAds,'card':comment.type === 'card','hover-effect':!isDeleted && !isCustomBuble && !isSticker, 'qcw-comment-prevsession':isPreviousSessionMessageNotifier, 'message__broadcast_button' : isMessageButtonBc}")

            //- Only for buble tip, for supporting js styling
            // div.tip(
            //   :style="tipMessageStyle"
            // )

            div(v-if="!isMe && isParent" class="qcw-comment__header")
              avatar(:src="commentAvatar(avatar)" :class="{'qcw-avatar--hide': !isParent}")

              //- Comment User
              //- span(class="qcw-comment__username" v-if="isParent && isGroupRoom && !isMe") {{comment.username_as}}
              span(class="qcw-comment__username" :class="{'qcw-comment__username--hide': isMe}" v-if="isParent" v-html="sanitizeHTML(username)")

            //- reply button
            div(class="reply-btn-wrapper" :style="!isInboxMode ? { right: '-35px !important' } : { right: '-53px'  }" v-if="!isDeleted && !isMe && !isSticker")
              i(@click="replyHandler(comment)" class="reply-btn" :class="{'reply-btn--me': isMe}")
                icon(name="ic-reply")
              span(class="qcw-comment__time--second") {{ isInboxMode ? timestamp : comment.time }}

            //- more vertical button
            div(class="qcw-comment__more-wrapper" :style="!isInboxMode ? { left: '-35px' } : { left: '-55px'  }" v-if="isMe && !isDeleted")
              i(class="qcw-comment__more" @click="menuMoreClicked(comment.id)")
                icon(name="ic-more-horiz")
              span(class="qcw-comment__time--second") {{ isInboxMode ? timestamp : comment.time }}

            div(
              :key="`comment_${comment.id}`"
              ref="`more_${comment.id}`"
              class="qcw-comment__more--menu"
              v-if="isMe && !isDeleted && showMenuMore && !isSticker"
              v-click-outside="onClickMenuOutside"
              )
              ul(v-if="!comment.isFailed")
                li(@click="replyHandler(comment)") Reply

            //- from tiktok ads
            div(v-if="isTiktokAdsComment")
              comment-tiktok-ads(:comment="comment")

            div(v-else-if="isMessageButtonBc" style="width: 100%;")
              comment-broadcast-button(:comment="comment" :message-style="messageStyle")
              span(v-if="isInboxMode" class="qcw-comment__time") {{comment.time}}
              //- State
              div(v-if="isMe")
                div(class="qcw-comment__state qcw-comment__state--sending" v-if="comment.isPending")
                  icon(name="ic-load" class="ic-load__state" :fill="messageStatusIconStyle")
                div(class="qcw-comment__state" v-if="!comment.isChannel && comment.isSent && !comment.isDelivered")
                  icon(name="ic-check" class="ic-check__state" :fill="messageStatusIconStyle")
                //- div(@click="resend(comment)" class="qcw-comment__state qcw-comment__state--failed"
                //-   v-if="comment.isFailed" :style="messageFailedIconStyle")
                //-   icon(name="ic-warning-circle" class="ic-failed__state")
                div(class="qcw-comment__state qcw-comment__state--delivered" v-if="!comment.isChannel && comment.status=='delivered'")
                   icon(name="ic-double-check" class="ic-double-check__state" :fill="messageStatusIconStyle")
                div(class="qcw-comment__state qcw-comment__state--read" v-if="!comment.isChannel && comment.status=='read'")
                   icon(name="ic-double-check" class="ic-double-check__state")

            //- from fb ads
            div(v-else-if="isFbAdsComment")

              comment-fb-ads(:comment="comment")

                //- CommentType: "TEXT"
                div(class="comment-text" v-if="(comment.type == 'text' || comment.type == 'reply') && !isSticker && !isInteractiveListMessage && !isInteractiveQuickReply && !isMediaTimeout && !isPreviousSessionMessageNotifier && !isInteractiveVoiceCall && !isInteractiveCallPermissionRequest && !isOutgoingCall")
                  image-loader(v-if="comment.isAttachment(comment.message) && comment.type != 'reply'"
                    :comment="comment"
                    :message="comment.message"
                    :whitelisted-files="whitelistedFiles"
                    :on-click-image="onClickImage"
                    :callback="onupdate"
                    :isMe="isMe")

                  comment-reply(v-if="comment.type =='reply'"
                    :comment="comment"
                    :isMe="isMe"
                    :whitelisted-files="whitelistedFiles"
                    :clickHandler="gotoComment"
                    :onClickImage="onClickImage"
                    :callback="onupdate")

                  comment-render(:text="comment.message" v-if="!comment.isAttachment(comment.message) && comment.type=='text'")

                //- CommentType: "file_attachment"
                file-attachment(v-if="comment.type == 'file_attachment'"
                  :comment="comment"
                  :whitelisted-files="whitelistedFiles"
                  :on-click-image="onClickImage"
                  :callback="onupdate"
                  :isMe="isMe")

                //- CommentCustom: "sticker"
                div(class="comment-sticker" v-if="comment.type == 'text' && isSticker")
                  image-loader(v-if="isSticker"
                    :comment="comment"
                    :message="comment.message.replace('[sticker]','[file]').replace('[/sticker]','[/file]')"
                    :whitelisted-files="whitelistedFiles"
                    :callback="onupdate"
                    :isMe="isMe")

                //- CommentType: "location"
                static-map(:lat="comment.payload.latitude"
                  :lng="comment.payload.longitude"
                  :name="comment.payload.name"
                  :mapkey="core.googleMapKey"
                  :message="comment.message"
                  :mapurl="comment.payload.map_url"
                  v-if="comment.type == 'location'")

                span(class="qcw-comment__time qcw-comment__time--children hidden-sm"
                  v-if="!isParent"
                  :class="{'qcw-comment__time--attachment': comment.isAttachment(comment.message)}") {{comment.time}}

                span(class="qcw-comment__time hidden-sm"
                  :class="{'qcw-comment__time--me': isMe}"
                  v-if="!isMe"
                  :style="messageTimeStyle") {{comment.time}}

                span(class="qcw-comment__time hidden-sm" v-else) {{comment.time}}

            div(v-else style="width: 100%;")
              //- CommentType: "location"
              static-map(:lat="comment.payload.latitude"
                :lng="comment.payload.longitude"
                :name="comment.payload.name"
                :mapkey="core.googleMapKey"
                :message="comment.message"
                :mapurl="comment.payload.map_url"
                v-if="comment.type == 'location'")

              //- CommentType: "contact_person"
              comment-contact(v-if="comment.type == 'contact_person'"
                :comment="comment")

              //- CommentType: "file_attachment"
              file-attachment(v-if="comment.type == 'file_attachment'"
                :comment="comment"
                :whitelisted-files="whitelistedFiles"
                :on-click-image="onClickImage"
                :callback="onupdate"
                :isMe="isMe")

              //- CommentType: "CAROUSEL"
              comment-carousel(:cards="comment.payload.cards" :mode="this.core.mode" v-if="comment.type === 'carousel'")

              //- CommentType: "CUSTOM"
              comment-custom(v-if="comment.type === 'custom' && comment.payload.type !== 'quickreply' && (comment.payload && comment.payload.type !== 'email_attachment')" :data="comment")

              //- comment CommentEmailAttachment
              comment-email-attachment(v-if="comment.type === 'custom' && (comment.payload && comment.payload.type === 'email_attachment')" :comment="comment" :isMe="isMe")

              //- CommentType: "BUTTON"
              div(v-if="comment.type == 'buttons'" class="button-message" :class="{'button-message__redownload': isRedownloadButton}")
                div
                  div(class="qcw-comment__content" :class="{'qcw-comment__content__redownload': isRedownloadButton}" v-html="comment.payload.text || comment.message")
                  comment-buttons(:buttons="comment.payload.buttons" :postbackHandler="postbackSubmit")
                  div(v-if="isRedownloadButton" class="qcw-comment__note")
                    i
                      icon(name="ic-info")
                    small You can only redownload an attachment file once

              //- CommentType: "BOT REPLY QUICK REPLY"
              div(v-if="comment.type === 'custom' && comment.payload.type === 'quickreply'" class="button-message")
                div
                  div(class="qcw-comment__content" v-html="comment.payload.text || comment.message")
                  comment-button-quick-reply(:content="comment.payload.content" :postbackHandler="postbackSubmit")

              //- CommentType: "CARD"
              comment-card(:data="comment.payload" v-if="comment.type==='card'")

              //- CommentType: "CARD"
              div(v-if="comment.type=='button_postback_response'" class="comment-text" @click.self="menuMoreClicked(null)")
                comment-render(:text="comment.message" v-if="!comment.isAttachment(comment.message) && !isRedownloadComment")
                comment-redownload(:message="comment.message+' File from '" :sender="comment.payload.payload.sender" :timestamp="comment.payload.payload.timestamp" v-if="isRedownloadComment")

              //- CommentType: "ACCOUNT_LINKING"
              div(v-if="comment.type == 'account_linking'")
                comment-render(:text="comment.payload.text || message")
                div(class="qcw-comment__buttons")
                  div(class="action_buttons")
                    button(@click="openAccountBox") {{ comment.payload.params.button_text }} &rang;

              //- CommentCustom: "sticker"
              div(class="comment-sticker" v-if="comment.type == 'text' && isSticker")
                image-loader(v-if="isSticker"
                  :comment="comment"
                  :message="comment.message.replace('[sticker]','[file]').replace('[/sticker]','[/file]')"
                  :whitelisted-files="whitelistedFiles"
                  :callback="onupdate"
                  :isMe="isMe")

              //- Interactive List Message
              div(v-if="isInteractiveListMessage" class="comment-text")
                div(v-if="!comment.isAttachment(comment.message) && comment.extras" class="qcw-comment__content")
                  div(v-if="comment.extras.header" class="qcw-interactive__header" v-html="comment.extras.header.value")
                  div(v-if="comment.extras.body" class="qcw-interactive__body" v-html="comment.extras.body")
                  div(v-if="comment.extras.footer && comment.extras.footer.text" class="qcw-interactive__footer" v-html="comment.extras.footer.text")
                  div(v-if="comment.extras.action && comment.extras.action.button" class="qcw-interactive__btn" v-html="comment.extras.action.button")
                  ul(v-if="comment.extras.action && comment.extras.action.sections.length > 0" v-for="(section, index) in comment.extras.action.sections" :key="index" class="qcw-interactive__section")
                    li(v-if="section.title" v-html="section.title" class="qcw-interactive__row--title qcw-interactive__bulleted--item")
                    div(v-if="section.rows.length > 0" v-for="row in section.rows" :key="row.id")
                      li(v-if="row.title" v-html="`(${row.title})`" class="qcw-interactive__row--title" :class="{'qcw-interactive__bulleted--item' : !section.title}")
                      li(v-if="row.description" v-html="row.description")

              //- Interactive Quick Reply
              div(v-if="isInteractiveQuickReply" class="comment-text")
                div(v-if="comment.extras" class="qcw-comment__content")
                  file-attachment(v-if="comment.extras.header && comment.extras.header.type !== 'text'"
                    :comment="comment"
                    :whitelisted-files="whitelistedFiles"
                    :on-click-image="onClickImage"
                    :callback="onupdate"
                    :isMe="isMe")
                  div(v-if="comment.extras.header && comment.extras.header.type === 'text'" class="qcw-interactive__header" v-html="comment.extras.header.value")
                  div(v-if="comment.extras.body" class="qcw-interactive__body" v-html="comment.extras.body")
                  div(v-if="comment.extras.footer && comment.extras.footer.text" class="qcw-interactive__footer" v-html="comment.extras.footer.text")
                  div(v-if="comment.extras.action && comment.extras.action.buttons.length > 0" v-for="button in comment.extras.action.buttons" :key="button.reply.id" class="qcw-interactive__btn--item")
                    div(class="qcw-interactive__btn--reply" v-html="button.reply.title")

              //- Media timeout
              div(v-if="isMediaTimeout" class="comment-text" style="max-width: 400px;")
                div(v-html="mediaTimeoutText" class="qcw-comment__content")
                div(style="display: flex; justify-content: center; margin-top: 16px;")
                  button(class="qcw-download-file-button" @click="onRedownloadMedia(comment)")
                    icon(name="ic-download-borderless" :fill="messageStatusIconStyle")
                    span() Download File

              //- Interactive Voice Call
              div(v-if="isInteractiveVoiceCall" class="comment-text")
                div(v-if="!comment.isAttachment(comment.message) && comment.extras" class="qcw-comment__content")
                  div(v-if="comment.extras.body" class="qcw-interactive__body" v-html="comment.extras.body")
                  hr(style="margin: 10px 0;border: 1px solid #FFFFFF;")
                  div(v-if="comment.extras.action && comment.extras.action.parameters" class="qcw-interactive__btn-call")
                    icon(name="ic-call")
                    span(v-html="comment.extras.action.parameters.display_text")

              // - Interactive Call Permission Request
              div(v-if="isInteractiveCallPermissionRequest" class="comment-text")
                div(v-if="!comment.isAttachment(comment.message) && comment.extras" class="qcw-comment__content" v-html='`Can Business call you in the next 7 days?` + (comment.message == "Business Call Request" || comment.message == "" ? "" : ` \n \n ${comment.message}`)')

              //- Outgoing Call Textcomment.message
              div(v-if="isOutgoingCall" class="qcw-call__outgoing")
                icon(name="ic-phone-outgoing-call")
                span(v-html="comment.extras.referral.call.content.header")
                span(v-html="comment.extras.referral.call.content.body")

              //- CommentType: "TEXT"
              div(class="comment-text" v-if="(comment.type == 'text' || comment.type == 'reply') && !isInteractiveListMessage && !isInteractiveQuickReply && !isMediaTimeout && !isPreviousSessionMessageNotifier && !isInteractiveVoiceCall && !isInteractiveCallPermissionRequest && !isOutgoingCall")
                file-attachment(v-if="comment.isAttachment(comment.message) && comment.type != 'reply'"
                  :comment="comment"
                  :whitelisted-files="whitelistedFiles"
                  :on-click-image="onClickImage"
                  :callback="onupdate"
                  :isMe="isMe")
                //- image-loader(v-if="comment.isAttachment(comment.message) && comment.type != 'reply'"
                //-   :comment="comment"
                //-   :message="comment.message"
                //-   :whitelisted-files="whitelistedFiles"
                //-   :on-click-image="onClickImage"
                //-   :callback="onupdate"
                //-   :isMe="isMe")

                //- Handle Replied message
                div(v-if="comment.extras.hasOwnProperty('replied_msg')"
                  class="reply-wrapper"
                  :class="{'reply-wrapper--me': isMe}"
                  style="cursor: default;")
                    div(class="reply-sender") {{ comment.payload.replied_comment_sender_username }}
                    div(class="reply-caption-container")
                      image-loader(v-if="comment.extras.replied_msg.type === 'file_attachment'"
                        :comment="comment"
                        :message="comment.extras.replied_msg.message"
                        :thumbnailMode="true"
                        :whitelisted-files="whitelistedFiles"
                        :on-click-image="onClickImage"
                        :callback="onupdate"
                        :is-comment-reply="false"
                        :isMe="isMe")
                      comment-render(v-if="comment.extras.replied_msg.type === 'text'" :text="comment.extras.replied_msg.message")

                comment-reply(v-if="comment.type =='reply'"
                  :comment="comment"
                  :isMe="isMe"
                  :whitelisted-files="whitelistedFiles"
                  :clickHandler="gotoComment"
                  :onClickImage="onClickImage"
                  :callback="onupdate")

                comment-catalog(:catalog="comment.extras.action" v-if="comment.extras.action && comment.extras.action.catalog_id")

                comment-interactive(:interactive="comment.extras.interactive" v-if="comment.extras.interactive && comment.extras.interactive.catalog_id")

                comment-render(
                  :comment="comment"
                  :text="comment.message"
                  v-if="!comment.isAttachment(comment.message) && comment.type=='text' && !isSticker && !isFlowResponse()"
                  :class="{'comment-text__interactive': comment.extras.interactive}")

                comment-order(:order="comment.extras.order" v-if="comment.extras.order && comment.extras.order.catalog_id")

                //- flow response bubble
                template(v-if="isFlowResponse()")
                  comment-flow-response(:comment="comment", :core="core")
                //- end of flow response bubble

              div(class="comment-text" v-if="comment.type == 'text' && isPreviousSessionMessageNotifier")
                image-loader(v-if="comment.isAttachment(comment.message)"
                  :comment="comment"
                  :message="comment.message"
                  :whitelisted-files="whitelistedFiles"
                  :on-click-image="onClickImage"
                  :callback="onupdate"
                  :isMe="isMe")
                comment-render(:text="comment.message" v-if="!comment.isAttachment(comment.message)")

              span(v-if="isInboxMode")
                span(class="qcw-comment__time qcw-comment__time--children"
                  v-if="!isParent"
                  :class="{'qcw-comment__time--attachment': comment.isAttachment(comment.message)}") {{comment.time}}

                span(class="qcw-comment__time"
                  :class="{'qcw-comment__time--me': isMe}"
                  v-if="!isMe"
                  :style="messageTimeStyle") {{comment.time}}

                span(class="qcw-comment__time" v-else) {{comment.time}}

              //- State
              div(v-if="isMe")
                div(class="qcw-comment__state qcw-comment__state--sending" v-if="comment.isPending")
                  icon(name="ic-load" class="ic-load__state" :fill="messageStatusIconStyle")
                div(class="qcw-comment__state" v-if="!comment.isChannel && comment.isSent && !comment.isDelivered")
                  icon(name="ic-check" class="ic-check__state" :fill="messageStatusIconStyle")
                //- div(@click="resend(comment)" class="qcw-comment__state qcw-comment__state--failed"
                //-   v-if="comment.isFailed" :style="messageFailedIconStyle")
                //-   icon(name="ic-warning-circle" class="ic-failed__state")
                div(class="qcw-comment__state qcw-comment__state--delivered" v-if="!comment.isChannel && comment.status=='delivered'")
                   icon(name="ic-double-check" class="ic-double-check__state" :fill="messageStatusIconStyle")
                div(class="qcw-comment__state qcw-comment__state--read" v-if="!comment.isChannel && comment.status=='read'")
                   icon(name="ic-double-check" class="ic-double-check__state")
          div(@click="resend(comment)" class="qcw-comment__state--failed" v-if="comment.isFailed && isMe" :style="messageFailedIconStyle")
            icon(name="ic-warning-circle" class="ic-failed__state")


    div(v-if="comment.extras.cards" class="qcw-comment-container" :class="{'comment--me': isMe, 'comment--last': isLast}")
      div(class="qcw-comment-container_carousel" :class="{'comment--me' : isMe}")
        avatar(:src="commentAvatar(avatar)" :class="{'qcw-avatar--hide': true}")
        comment-wa-carousel(:comment="comment" :id="comment.id" :whitelisted-files="whitelistedFiles" :message-style="{marginBottom: '4px', backgroundColor: '#ffffff'}")

    div(v-if="comment.extras.is_echo" class="qcw-comment-container" :class="{'comment--me': isMe, 'comment--last': isLast}")
      div(class="qcw-comment-container_echo" :class="{'comment--me' : isMe}")
        avatar(:src="commentAvatar(avatar)" :class="{'qcw-avatar--hide': true}")
        comment-wa-coexistence

    div(class="failed-info" v-if="comment.isFailed"
      :class="{ 'failed--last': isLast }") Message failed to send.
      span(@click="resend(comment)" class="" v-if="comment.isFailed" :class="{'resend--inbox': isInboxMode}") Resend

</template>

<script>
import QiscusCore from "../lib/SDKCore";
import Avatar from "./Avatar";
import Icon from "./Icon";
import StaticMap from "./StaticMap";
import ImageLoader from "./ImageLoader";
import FileAttachment from "./FileAttachment";
import CommentRender from "./CommentRender";
import CommentRedownload from "./CommentRedownload";
import CommentReply from "./CommentReply";
import CommentCustom from "./CommentCustom";
import CommentCarousel from "./CommentCarousel";
import CommentCard from "./CommentCard";
import CommentButtons from "./CommentButtons";
import CommentButtonQuickReply from "./CommentButtonQuickReply.vue";
import CommentContact from "./CommentContact";
import CommentEmailAttachment from "./CommentEmailAttachment";
import CommentFbAds from "./CommentFbAds";
import CommentTiktokAds from "./CommentTiktokAds.vue";
import clickOutside from "../lib/clickOutside";
import CommentOrder from "./CommentOrder";
import CommentCatalog from "./CommentCatalog";
import CommentInteractive from "./CommentInteractive";
import CommentWaCarousel from "./CommentWaCarousel.vue";
import Mime from "mime-types";
import CommentWaCoexistence from "./CommentWaCoexistence.vue";
import CommentFlowResponse from "./CommentFlowResponse.vue";
import CommentBroadcastButton from "./CommentBroadcastButton.vue";

export default {
  name: "Comment",
  components: {
    Avatar,
    Icon,
    StaticMap,
    ImageLoader,
    FileAttachment,
    CommentRender,
    CommentRedownload,
    CommentReply,
    CommentCustom,
    CommentCarousel,
    CommentCard,
    CommentButtons,
    CommentButtonQuickReply,
    CommentContact,
    CommentOrder,
    CommentCatalog,
    CommentInteractive,
    CommentEmailAttachment,
    CommentFbAds,
    CommentWaCarousel,
    CommentTiktokAds,
    CommentWaCoexistence,
    CommentFlowResponse,
    CommentBroadcastButton
  },
  props: [
    "comment",
    "commentBefore",
    "commentAfter",
    "userData",
    "onClickImage",
    "onupdate",
    "replyHandler",
    "showAvatar",
    "currentMenuId",
    "isSticker",
    "roomName",
    "stickerUrl",
    "customerEmail",
    "isInteractiveListMessage",
    "isInteractiveQuickReply",
    "isInteractiveVoiceCall",
    "isInteractiveCallPermissionRequest",
    "isOutgoingCall"
  ],
  directives: { clickOutside },
  computed: {
    timestamp() {
      const date = new Date(this.comment.timestamp);
      const h = String(date.getHours()).padStart("2", "0");
      const m = String(date.getMinutes()).padStart("2", "0");
      const s = String(date.getSeconds()).padStart("2", "0");

      return `${h}:${m}:${s}`;
    },
    isRedownloadComment() {
      if (
        this.comment.payload &&
        this.comment.payload.payload &&
        this.comment.payload.payload.sub_type
      ) {
        return this.comment.payload.payload.sub_type === "redownload";
      }
      return false;
    },
    isRedownloadButton() {
      if (
        this.comment.type === "buttons" &&
        this.comment.payload.buttons &&
        this.comment.payload.buttons.length > 0
      ) {
        const payload = this.comment.payload.buttons[0].payload.payload;
        if (payload) return payload.sub_type === "redownload";
      }
      return false;
    },
    isChannel() {
      return this.comment.isChannel;
    },
    isDeleted() {
      return this.comment.is_deleted === true;
    },
    isCustomBuble() {
      return this.comment.type === "card";
    },
    showDate() {
      return (
        this.commentBefore === null ||
        this.commentBefore.date !== this.comment.date
      );
    },
    addExtraMargin() {
      if (this.commentBefore === null) return false;
      let commentBeforeEmail = this.commentBefore.hasOwnProperty(
        "username_real"
      )
        ? this.commentBefore.username_real.toString()
        : "";
      let commentEmail = this.comment.hasOwnProperty("username_real")
        ? this.comment.username_real.toString()
        : "";
      if (
        this.commentBefore.extras &&
        this.commentBefore.extras.alternate_user
      ) {
        if (this.commentBefore.extras.alternate_user.hasOwnProperty("email")) {
          commentBeforeEmail = this.commentBefore.extras.alternate_user.email.toString();
        }
      }
      if (this.comment.extras && this.comment.extras.alternate_user) {
        if (
          this.comment.extras.alternate_user.hasOwnProperty("email") &&
          this.comment.extras.alternate_user.email
        ) {
          commentEmail = this.comment.extras.alternate_user.email.toString();
        }
      }
      return commentBeforeEmail === commentEmail;
    },
    isPreviousSessionMessageNotifier() {
      const textToFind = "This message was sent on previous session by";
      let placeToFind = this.comment.message;
      if (
        this.comment.type === "file_attachment" &&
        this.comment.payload.caption
      ) {
        placeToFind = this.comment.payload.caption;
      }
      return placeToFind.includes(textToFind);
    },
    isParent() {
      if (this.commentBefore === null) return true;
      let commentBeforeEmail =
        this.commentBefore.hasOwnProperty("username_real") &&
          this.commentBefore.username_real
          ? this.commentBefore.username_real.toString()
          : "";
      let commentEmail =
        this.comment.hasOwnProperty("username_real") &&
          this.comment.username_real
          ? this.comment.username_real.toString()
          : "";
      if (
        this.commentBefore.extras &&
        this.commentBefore.extras.alternate_user
      ) {
        if (
          this.commentBefore.extras.alternate_user.hasOwnProperty("email") &&
          this.commentBefore.extras.alternate_user.email
        ) {
          commentBeforeEmail = this.commentBefore.extras.alternate_user.email.toString();
        }
      }
      if (this.comment.extras && this.comment.extras.alternate_user) {
        if (
          this.comment.extras.alternate_user.hasOwnProperty("email") &&
          this.comment.extras.alternate_user.email
        ) {
          commentEmail = this.comment.extras.alternate_user.email.toString();
        }
      }
      return commentBeforeEmail !== commentEmail;
    },
    isGroupRoom() {
      return this.core.selected.room_type === "group";
    },
    isMid() {
      if (this.commentAfter === null) return false;

      let commentAfterEmail =
        this.commentAfter.hasOwnProperty("username_real") &&
          this.commentAfter.username_real
          ? this.commentAfter.username_real.toString()
          : "";
      let commentEmail =
        this.comment.hasOwnProperty("username_real") &&
          this.comment.username_real
          ? this.comment.username_real.toString()
          : "";

      if (this.commentAfter.extras && this.commentAfter.extras.alternate_user) {
        if (
          this.commentAfter.extras.alternate_user.hasOwnProperty("email") &&
          this.commentAfter.extras.alternate_user.email
        ) {
          commentAfterEmail = this.commentAfter.extras.alternate_user.email.toString();
        }
      }
      if (this.comment.extras && this.comment.extras.alternate_user) {
        if (
          this.comment.extras.alternate_user.hasOwnProperty("email") &&
          this.comment.extras.alternate_user.email
        ) {
          commentEmail = this.comment.extras.alternate_user.email.toString();
        }
      }
      return !this.isParent && commentAfterEmail === commentEmail;
    },
    isLast() {
      if (this.commentAfter === null) return true;
      let commentAfterEmail = this.commentAfter.hasOwnProperty("username_real")
        ? this.commentAfter.username_real.toString()
        : "";
      let commentEmail = this.comment.hasOwnProperty("username_real")
        ? this.comment.username_real.toString()
        : "";
      if (this.commentAfter.extras && this.commentAfter.extras.alternate_user) {
        if (
          this.commentAfter.extras.alternate_user.hasOwnProperty("email") &&
          this.commentAfter.extras.alternate_user.email
        ) {
          commentAfterEmail = this.commentAfter.extras.alternate_user.email.toString();
        }
      }
      if (this.comment.extras && this.comment.extras.alternate_user) {
        if (
          this.comment.extras.alternate_user.hasOwnProperty("email") &&
          this.comment.extras.alternate_user.email
        ) {
          commentEmail = this.comment.extras.alternate_user.email.toString();
        }
      }
      return commentAfterEmail !== commentEmail;
    },
    isMe() {
      let userDataEmail =
        this.userData.hasOwnProperty("email") && this.userData.email
          ? this.userData.email.toString()
          : "";
      let usernameReal =
        this.comment.hasOwnProperty("username_real") &&
          this.comment.username_real
          ? this.comment.username_real.toString()
          : "";

      if (this.comment.extras && this.comment.extras.alternate_user) {
        if (
          this.comment.extras.alternate_user.hasOwnProperty("email") &&
          this.comment.extras.alternate_user.email
        ) {
          usernameReal = this.comment.extras.alternate_user.email.toString();
        }
      }
      if (this.core.UI.alternateUser) {
        userDataEmail =
          this.core.UI.alternateUser.hasOwnProperty("email") &&
            this.core.UI.alternateUser.email
            ? this.core.UI.alternateUser.email.toString()
            : "";
      }
      return usernameReal === userDataEmail;
    },
    isCustomer() {
      return (
        typeof this.comment.user_extras === "undefined" ||
        typeof this.comment.user_extras.type === "undefined" ||
        this.comment.user_extras.type !== "agent"
      );
    },
    showMenuMore() {
      if (!this.currentMenuId) return false;
      return this.comment.id === this.currentMenuId;
    },
    isReplayBot() {
      return (
        this.comment.extras &&
        Object.keys(this.comment.extras).length > 0 &&
        this.comment.extras.action === "bot_reply"
      );
    },
    username() {
      if (this.comment.extras && this.comment.extras.alternate_user) {
        return this.comment.extras.alternate_user.hasOwnProperty("name")
          ? this.comment.extras.alternate_user.name.toString()
          : "";
      }
      return this.comment.username_as;
    },
    avatar() {
      if (this.comment.extras && this.comment.extras.alternate_user) {
        return this.comment.extras.alternate_user.hasOwnProperty("avatar") &&
          this.comment.extras.alternate_user.avatar
          ? this.comment.extras.alternate_user.avatar.toString()
          : "";
      }
      return this.comment.avatar;
    },
    isFbAdsComment() {
      return (
        this.comment.extras &&
        this.comment.extras.referral &&
        this.comment.extras.referral.source_type &&
        (this.comment.extras.referral.source_type === "ad" ||
          this.comment.extras.referral.source_type === "post")
      );
    },
    isTiktokAdsComment() {
      return (
        this.comment.extras &&
        this.comment.extras.referral &&
        this.comment.extras.referral.source &&
        this.comment.extras.referral.source === "ad" &&
        this.comment.extras.referral.ad &&
        this.comment.extras.referral.ad.ad_id
      );
    },
    isMessageButtonBc() {
      return (
        this.comment.extras &&
        this.comment.extras.broadcast_message &&
        this.comment.extras.broadcast_message.is_broadcast &&
        this.comment.type === "text" &&
        this.comment.extras.broadcast_message &&
        !this.comment.extras.is_carousel
      );
    },
    isStickerAds() {
      return this.isSticker && this.isFbAdsComment;
    },
    isCarousel() {
      return this.comment.extras && this.comment.extras.is_carousel;
    },
    whitelistedFiles() {
      if (
        this.core.UI.whitelistedFiles &&
        this.core.UI.whitelistedFiles !== ""
      ) {
        return this.core.UI.whitelistedFiles.split(",");
      }
      return [];
    },
    isMediaTimeout() {
      if (!this.core.selected || !("options" in this.core.selected))
        return false;
      const check = this.core.selected.options
        ? JSON.parse(this.core.selected.options)
        : {};
      const isWaChannel =
        Object.keys(check).length > 0
          ? check.channel.toLowerCase().includes("wa")
          : false;

      return (
        isWaChannel &&
        this.comment.extras &&
        this.comment.extras.media_id &&
        this.comment.message
          .toLowerCase()
          .includes(
            "the message sent by the customer cannot be rendered because it has timeout"
          )
      );
    },
    mediaTimeoutText() {
      let desc = this.comment.message;
      let newDesc = desc.split("because");

      newDesc[1] =
        "due to a timeout. However, you can still download the file by clicking the download button.";
      desc = newDesc.join("");
      return desc;
    },
    isMeFileImageAttachment() {
      return (
        this.isMe &&
        this.comment.message.match(/\.(jpg|jpeg|gif|png|webp|mov|mp4|webm)/i) !=
        null &&
        this.comment.payload.caption == ""
      );
    },
    isInboxMode() {
      return this.core.UI.displayMode === "inbox";
    },
    dateToday() {
      const inboxDateConfig = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      };

      const liveChatDateConfig = {
        year: "numeric",
        month: "long",
        day: "numeric"
      };

      const dateConfig = !this.isInboxMode
        ? liveChatDateConfig
        : inboxDateConfig;

      return new Date(this.comment.date).toLocaleString("en-US", dateConfig);
    }
  },
  data() {
    return {
      messageStyle: {},
      tipMessageStyle: {},
      messageStatusIconStyle: { fill: QiscusUI.colors.messageStatusIconColor },
      messageFailedIconStyle: { fill: QiscusUI.colors.messageFailedIconColor },
      messageTimeStyle: { color: QiscusUI.colors.messageTimeColor },
      core: QiscusCore
    };
  },
  mounted() {
    if (!this.isCustomBuble && !this.isMeFileImageAttachment) {
      this.messageStyle = {
        color: this.isMe
          ? this.core.UI.colors.bubleRightTextColor
          : this.core.UI.colors.bubleLeftTextColor,
        background: this.isMe
          ? this.core.UI.colors.bubleRightColor
          : this.core.UI.colors.bubleLeftColor
      };
      this.tipMessageStyle = {
        borderLeftColor: this.isMe
          ? this.core.UI.colors.bubleRightColor
          : "transparent",
        borderRightColor: this.isMe
          ? "transparent"
          : this.core.UI.colors.bubleLeftColor
      };
    }
  },
  methods: {
    renderPreviousSessionMessage(msg) {
      if (!msg.message.startsWith("[file]")) return msg.message;
      return `File Attachment: ${msg.message
        .replace("[file]", "")
        .replace("[/file]", "")
        .trim()}`;
    },
    sanitizeHTML(content) {
      return content
        ? content.replace(/</g, "&lt;").replace(/>/g, "&gt;")
        : content;
    },
    unsanitizeHTML(content) {
      return content
        ? content.replace(/(&gt;)/g, ">").replace(/(&lt;)/g, "<")
        : content;
    },
    onClickMenuOutside() {
      if (this.currentMenuId) this.menuMoreClicked(null);
    },
    gotoComment() {
      const commentId = this.comment.payload.replied_comment_id;
      const element = document.getElementById(commentId);
      let ofs = 0;
      let timer = 1;

      if (!element) {
        return this.$emit("commentNotFound", commentId);
      }

      const blink = window.setInterval(() => {
        element.style.background = `rgba(255, 252, 218, ${Math.abs(
          Math.sin(ofs)
        )})`;
        ofs += 0.05;
        timer += 1;
        if (timer === 300) {
          window.clearInterval(blink);
          element.style.background = "transparent";
        }
      }, 10);

      return element.scrollIntoView({ block: "end", behaviour: "smooth" });
    },
    resend(comment) {
      const commentToBeSent = Object.assign({}, comment);
      commentToBeSent.payload = JSON.stringify(commentToBeSent.payload);
      return this.core.resendComment(commentToBeSent).then(
        () => this.$toasted.success("Resending comment successful"),
        () => this.$toasted.error("Resending comment failed")
      );
    },
    confirmDeleteComment(comment) {
      this.menuMoreClicked(null);
      const actions = [];
      actions.push({
        text: "Yes",
        onClick: () =>
          this.deleteComment(comment, true).then(
            () => {
              this.$toasted.success("Message deleted");
            },
            () => {
              this.$toasted.error("Failed deleting message");
            }
          )
      });
      actions.push({
        text: "Cancel",
        onClick: (e, toastObject) => toastObject.goAway(0)
      });
      return this.$toasted.show("Are you sure to delete this message?", {
        duration: 5000,
        action: actions
      });
    },
    deleteComment(comment, isForEveryone) {
      this.$toasted.clear();
      if (comment.isFailed) return this.deleteLocalComment(comment);
      const roomId = this.core.selected.id;
      const commentIds = [comment.unique_id];
      const commentIndex = this.core.selected.comments.findIndex(
        c => comment.unique_id === c.unique_id
      );
      if (commentIndex && comment.before_id < 1) {
        this.core.selected.comments[commentIndex + 1].before_id = 0;
      }
      return this.core.deleteComment(roomId, commentIds, isForEveryone, true);
    },
    deleteLocalComment(comment) {
      const comments = this.core.selected.comments;
      const commentToBeFound = comments.findIndex(
        com => com.unique_id === comment.unique_id
      );
      if (commentToBeFound > -1) comments.splice(commentToBeFound, 1);
      return Promise.resolve(comments);
    },
    haveTemplate(comment) {
      if (!this.core.customTemplate) return false;
      return this.core.templateFunction(comment);
    },
    postbackSubmit(button) {
      const roomId = this.core.selected.id;
      const labelToSend = button.postback_text
        ? button.postback_text
        : button.label;
      const nanotimestamp =
        window.performance.now() + window.performance.timeOrigin;
      const uniqueId = `${roomId}_${nanotimestamp}`;
      this.core
        .sendComment(
          roomId,
          labelToSend,
          uniqueId,
          "button_postback_response",
          JSON.stringify(button.payload)
        )
        .then(res => {
          this.core.options.sentMessageCallback(res);
        });
    },
    openAccountBox() {
      window.open(
        this.comment.payload.url,
        "AccountLinkingPopup",
        "width=500,height=400,location=no,menubar=no,resizable=1,status=no,toolbar=no"
      );
    },
    messageInfoHandler(comment) {
      this.core.UI.isMessageInfoActive = true;
      this.core.UI.messageInfoData = {
        comment
      };
    },
    menuMoreClicked(id) {
      const commentId = this.currentMenuId === id ? null : id;
      this.$emit("onChangeMenu", commentId);
    },
    commentAvatar(avatar) {
      if (avatar) {
        if (avatar.includes("//image.flaticon.com/icons")) {
          return "https://multichannel.qiscus.com/img/default_avatar.svg";
        }
        return avatar;
      }
      return this.core.avatar_url;
    },
    onRedownloadMedia(data) {
      return new Promise((resolve, reject) => {
        const check = this.core.selected.options
          ? JSON.parse(this.core.selected.options)
          : {};
        const { _appUrl, _authToken } = window.qenv;
        const url = `${_appUrl}/whatsapp/v1/${this.core.AppId}/${check.channel_id}/media/${data.extras.media_id}`;
        const xhr = new XMLHttpRequest();
        xhr.responseType = "blob";

        xhr.open("GET", url, true);
        xhr.setRequestHeader("Authorization", _authToken);
        xhr.setRequestHeader("Qiscus-App-Id", this.core.AppId);
        xhr.setRequestHeader("Accept", "application/json");

        xhr.addEventListener("error", () => {
          this.$toasted.error("Error download file");
          reject(new Error("Error download file"));
        });

        xhr.addEventListener("load", () => {
          if (xhr.status === 200) {
            const contentType = xhr.getResponseHeader("Content-Type");
            const blob = new Blob([xhr.response], { type: contentType });
            const extension = Mime.extension(contentType);
            const filename = `${data.extras.media_id}.${extension}`;
            const link = document.createElement("a");

            document.body.appendChild(link);
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
            document.body.removeChild(link);
            this.$toasted.success("File downloaded Successfully");
            resolve();
          } else {
            this.$toasted.error("Error download file");
            reject(new Error("Error download file"));
          }
        });

        xhr.send();
      });
    },
    isFlowResponse() {
      if (
        this.comment &&
        this.comment.extras &&
        this.comment.extras.interactive &&
        this.comment.extras.interactive.type === "nfm_reply" &&
        this.comment.extras.interactive.nfm_reply.name === "flow"
      ) {
        return true;
      }
      return false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Comment.vue